
export default class CookieService {
  ACTIVE_ASSIGNMENT_ID = 'active-assignment-id';

  save(cookieName, cookieValue) {
    document.cookie = `${cookieName}=${cookieValue}; path=/`
  }

  load(cookieName) {
    let re = new RegExp('[; ]' + cookieName + '=([^\\s;]*)');
    let sMatch = (' ' + document.cookie).match(re);
    if (cookieName && sMatch) return unescape(sMatch[1]);
    return '';
  }
}